// Shared key helpers for the chat workspace stores.

import { STORAGE_KEYS } from '@/shared/storage';
import type { ChatLoginScope } from './types';

const VERSION = 'v2';

function normalizeScopePart(value: string): string {
  const normalized = value.trim();
  if (normalized.length === 0) {
    throw new Error('chat workspace scope parts must be non-empty');
  }
  return encodeURIComponent(normalized);
}

export function createChatWorkspaceStorageKey(scope: ChatLoginScope): string {
  return `${STORAGE_KEYS.chatWorkspace}:${VERSION}:${normalizeScopePart(scope.userId)}:${normalizeScopePart(scope.loginSessionId)}`;
}

export function createChatWorkspaceChannelName(scope: ChatLoginScope): string {
  return `${createChatWorkspaceStorageKey(scope)}:sync`;
}
